import * as React from 'react';
import { DayPicker } from 'react-day-picker';
import clsx from 'clsx';
import { CalendarLeft, CalendarRight } from '../../icons/arrows/calendarArrows';

function Calendar({ className, classNames, showOutsideDays = true, ...props }) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={clsx(
        'lg:p-3 bg-white lg:shadow-lg rounded-[12px] py-6 lg:px-10',
        className
      )}
      classNames={{
        months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
        month: 'space-y-4 w-full',
        caption: 'flex justify-center pt-1 px-8 relative items-center',
        caption_label: 'h3 mx-5',
        nav: 'space-x-1 flex items-center',
        nav_button: clsx(
          'h-11 w-11 bg-white rounded-full drop-shadow flex items-center justify-center'
        ),
        nav_button_previous: 'absolute left-0',
        nav_button_next: 'absolute right-0',
        table: 'w-full border-collapse space-y-1',
        head_row: 'flex w-full justify-between',
        head_cell: 'h4 w-8',
        row: 'flex w-full justify-between',
        cell: clsx(
          'relative text-center focus-within:relative focus-within:z-20 [&:has([aria-selected])]:text-white [&:has([aria-selected])]:bg-accent [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected].day-range-end)]:rounded-r-md',
          props.mode === 'range'
            ? '[&:has(>.day-range-end)]:rounded-r-md [&:has(>.day-range-start)]:rounded-l-md first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md'
            : '[&:has([aria-selected])]:rounded-md'
        ),
        day: clsx(
          'p-0 font-normal aria-selected:opacity-100 w-8 rounded-[6px] h-8'
        ),
        day_range_start: 'day-range-start',
        day_range_end: 'day-range-end',
        day_selected:
          'bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground',
        day_today: 'bg-accent text-accent-foreground',
        day_outside:
          'day-outside text-muted-foreground opacity-50  aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30',
        day_disabled: 'text-muted-foreground opacity-50',
        day_range_middle:
          'aria-selected:bg-accent aria-selected:text-accent-foreground',
        day_hidden: 'invisible',
        ...classNames,
      }}
      components={{
        IconLeft: ({ ...props }) => <CalendarLeft />,
        IconRight: ({ ...props }) => <CalendarRight />,
      }}
      {...props}
    />
  );
}
Calendar.displayName = 'Calendar';

export { Calendar };
